class ScrollTickerLogos {
    constructor() {
        this.DOM = {
            body: document.body
        };

        this.selector = '.client-logo-ticker';
        this.viewportWidth = document.documentElement.clientWidth || window.innerWidth;

        setTimeout(() => {
            this.setImageTickerMove();
        }, 200);
        setTimeout(() => {
            this.initImageTickerscrub();
        }, 1000);
    }

    setImageTickerMove() {
        const tickerContent = document.querySelector(`${this.selector} .ticker-content.main`);
        if (!tickerContent) {
            return;
        }
        const tickerContentWidth = tickerContent.offsetWidth;
        const tickerMove = `-${tickerContentWidth}px`;
        var r = document.querySelector(':root');
        r.style.setProperty('--ticker-move', tickerMove);

        // Set animation after amount of movement is determined. Vars in css animation not updating.
        const tickerSpeed = tickerContentWidth / 60;

        // console.log('tickerContentWidth', tickerContentWidth);
        // console.log('tickerSpeed :', tickerSpeed);

        const tickerSpeedSeconds = `${tickerSpeed}s`;
        const tickerLoop = document.querySelector(`${this.selector} .ticker-loop`);
        tickerLoop.style.animation = `scroll ${tickerSpeedSeconds} linear infinite`;
    }

    initImageTickerscrub() {
        if (!document.querySelector(`${this.selector} .ticker .scroll-scrubber`)) {
            return;
        }

        const distanceX = (this.viewportWidth / 100) * 20 * -1;
        // console.log('distanceX :', distanceX);

        gsap.to(`${this.selector} .ticker .scroll-scrubber`, {
            scrollTrigger: {
                // markers: true,
                trigger: `${this.selector} .ticker`,
                scrub: 1,
                start: 'top bottom',
                end: 'bottom top'
            },
            x: distanceX
        });
    }
}
new ScrollTickerLogos();
